<div class="device-container">
  <div class="axonDevicePopupHeader">
    <div class="axonDeviceActions">
      <button
        mat-icon-button
        class="popout-button"
        (click)="openFeaturePopout()"
        *ngIf="!!data.openPopout"
        matTooltip="Unlock Popup"
      >
        <sn-icon fontSet="fal" fontIcon="fa-unlock"></sn-icon>
      </button>
      <button mat-icon-button class="popout-button" (click)="dock()" matTooltip="Dock Livestream">
        <sn-icon fontSet="fal" fontIcon="fa-video"></sn-icon>
      </button>
    </div>
    <button
      mat-icon-button
      class="axonDeviceOptions"
      [matMenuTriggerFor]="axonDeviceMenu"
      matTooltip="Options"
    >
      <sn-icon fontSet="far" fontIcon="fa-ellipsis-v"></sn-icon>
    </button>
  </div>
  <fs-axon-livestream-iframe
    [device]="data.marker.device"
    [isDocked]="false"
  ></fs-axon-livestream-iframe>
</div>
<mat-menu #axonDeviceMenu="matMenu">
  <button mat-menu-item (click)="dock()">
    <sn-icon fontSet="fal" fontIcon="fa-video"></sn-icon>
    <span>Dock Livestream</span>
  </button>
  <button mat-menu-item *ngIf="!data.marker.getFollowMode()" (click)="followMode()">
    <sn-icon fontSet="fal" fontIcon="fa-arrows-up-down-left-right"></sn-icon>
    <span>Follow Mode</span>
  </button>
</mat-menu>
